/**
 * Manages the registration and application of plugins for the Tree Item.
 * This will be replaced with a proper implementation in the future.
 */
export class TreeViewItemPluginManager {
  itemPlugins = [];
  itemWrappers = [];
  register = (plugin, wrapItem) => {
    this.itemPlugins.push(plugin);
    if (wrapItem) {
      this.itemWrappers.push(wrapItem);
    }
  };
  listPlugins = () => this.itemPlugins;
  listWrappers = () => this.itemWrappers;
}